
// 岗位管理
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" @resetEvent="resetEvent" :_dataId.sync="dataId"
					:parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" >

					<div class="table_main" style="height: calc(100vh - -30px);">
						<vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
											@click="openEditDialog">新增</vxe-button>
<!--                      <vxe-button status="primary" class="button-sty" icon="el-icon-top"-->
<!--                       @click="openEditDialog">导入-->
<!--              </vxe-button>-->
<!--              <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"-->
<!--               @click="openEditDialog">导出-->
<!--              </vxe-button>-->
									</div>
									<div class="fr">
<!--										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--											status="primary" plain>重置</vxe-button>-->
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
									<vxe-form-item title="岗位名称:" field="postName">
										<template v-slot>
											<el-input v-model="formData.postName" size="small" clearable />
										</template>
									</vxe-form-item>

								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
        <!-- <template #dsType="{ row }">
          <span class="txt-status2" v-if="row.dsType==0">全部</span>
          <span class="txt-status2" v-else-if="row.dsType==1">自定义</span>
          <span class="txt-status2" v-else-if="row.dsType==2">本级及子级</span>
          <span class="txt-status2" v-else-if="row.dsType==3">本级</span>
         <span v-else></span>
        </template> -->
						</vxe-grid>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import editView from './edit.vue';
import {indexPageMixins} from '@/mixins/tabChang'
import {initVxeTable} from '@/const/crud/admin/table';
// import {fetchTree} from "@/api/admin/dept";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {fetchMenuTree} from '@/api/admin/menu'
import {addObj, delObj, fetchList, fetchRoleTree, permissionUpd, putObj} from '@/api/admin/post'
export default {
	name: 'post',

	inject: ['reload'],
  mixins: [indexPageMixins],
	components: { editView, pager },
	data() {
		return {
      dialogPermissionVisible: false,
      treeData: [],
      checkedKeys: [],
      postId: undefined,
      roleCode: undefined,
      menuIds: '',
      total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
				current: 1,
				searchCount: false,
				id: '',
			},
		};
	},
	mounted() {
		// this.initTableList();
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
	},
	methods: {
		toFilterData() {
            this.searchEvent();
     },

		// 	// 请求总数
		// getNewCount(val){
		// 	console.log(val,"val的值--请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// // 不请求总数
		// getNewCount2(val){
		// 	console.log(val,"val的值--不请求总数");
		// 	this.formData.searchCount=val
		// 	  this.$refs['table-m1'].commitProxy('reload');
		// },
		// el-tab 监视切换事件
		handleClick(tab, event) {
			console.log(tab, event);

		},

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.getTableData();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		// 搜索
		searchEvent() {
			this.$refs.pager.clearStoreTableDataTotal()
			this.formData.current = 1
			this.$refs['table-m1'].commitProxy('reload');

		},
		// 重置
		resetEvent() {
			this.formData = {};
			this.formData.addresswangdian = {};
			this.$refs.pager.reset()  // 重置分页器
			this.$refs['table-m1'].commitProxy('reload');
		},
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		deletes(id) {
			// this.dataId = !id || typeof id == 'object' ? 0 : id;
			// this.activeName = 'first';
			// this.$openEditView('showEdit');
			console.log(id,"删除所选的ID");
			this.$baseConfirm('您确定要删除吗？').then(() => {
				this.$http({
                url: '/admin/post/'+id,
                method: `delete`,

              }).then(() => {
                   this.$message.success("删除成功！");
				   this.reload()

              }).catch(e => {
                // console.error(e)
                // this.$message.error("保存失败！");
              })

			})
		},
    getTableData() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/admin/post/page',
				param: this.formData,
				method: 'get',

				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '岗位名称',
						field: 'postName',
						width: 140,
						// fixed: 'left'
					},
					{
						title: '岗位标识',
						field: 'postCode',
						width: 150,
					},

					{
						field: 'createTime',
						title: '创建时间',
						width: 180
					},

					{
						width: 120,
						fixed: 'right',
						title: '操作',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.postId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
                    <a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.deletes(row.postId);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-delete" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
			this.$refs['table-m1'].commitProxy('reload');
			// console.log(initVxeTable(tableOption),"vxeOption-表头的值及属性");
			// });
		},
		// 加载页面
		loadChildNode(node, resolve) {
			console.log(node, "loadChildNode.node")
      this.$http.post(api.userTree.getTree,{
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值")
        resolve(
          data.data.map(item => {
            return {
              label: item.name,
              id: item.id,
              leaf: Number(item.hasChild) == 1 ? false : true,
            }
          })
        )
      });
			// this.treeData=data.data
		},
	}
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;

	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}
::v-deep .vxe-grid .a-link {
    margin-right: -3px !important;
}
.el-dialog__wrapper {
  .el-dialog {
    // width: 61% !important;

    .dialog-main-tree {
      max-height: 450px;
      overflow-y: auto;
    }
  }

  .el-form-item__label {
    width: 20% !important;
    padding-right: 20px;
  }

  .el-form-item__content {
    margin-left: 20% !important;
  }
}
</style>

